import { Model } from "@vuex-orm/core";
import SiteGroup from "@/models/site_group";

export default class User extends Model {
  static entity = "users";

  static fields() {
    return {
      id: this.attr(null),
      username: this.attr(""),
      role: this.attr("general"),
      site_group: this.belongsTo(SiteGroup, "site_group_id"),
      site_group_id: this.attr(null),
    };
  }
}
